/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.workflows').controller('WorkflowsDatePropertiesSectionController', function($scope, SearchFilterService){
    var self=this;

    self.searchCriteria = SearchFilterService.workflowSearchCriteria;

    self.selectedDateProperty = SearchFilterService.workflowSearchCriteria.dateProperty || '';
    self.selectedDateProperties = {
        'startDate': {
            fromDate: (SearchFilterService.workflowSearchCriteria.dateProperty === 'startDate') ? SearchFilterService.workflowSearchCriteria.fromDate : new Date(),
            toDate: (SearchFilterService.workflowSearchCriteria.dateProperty === 'startDate') ? SearchFilterService.workflowSearchCriteria.toDate : new Date()
        }
    };
    self.recentDays = SearchFilterService.workflowSearchCriteria.recentDays || 14;

    $scope.$on('modal.closing', function () {
        SearchFilterService.workflowSearchCriteria.recentDays = self.recentDays;
        SearchFilterService.workflowSearchCriteria.dateProperty = self.selectedDateProperty;
        SearchFilterService.workflowSearchCriteria.fromDate = (self.selectedDateProperty === 'startDate')?  self.selectedDateProperties[self.selectedDateProperty].fromDate : null;
        SearchFilterService.workflowSearchCriteria.toDate = (self.selectedDateProperty === 'startDate')? self.selectedDateProperties[self.selectedDateProperty].toDate : null;
    });
});
